import React from 'react'
import styles from './styles.css'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import useState from 'App/hooks/useState'
import useDebounce from 'App/hooks/useDebounce'
import Select from 'react-select'

export default function DriverField(props) {
  const [filter, setFilter] = useState('')
  const [debouncedFilter, isDebouncing] = useDebounce(filter, 400)

  const {vehicles, networkStatus} = useQuery({
    query: gql`
      query getVehicles($filter: String) {
        vehicles(limit: 10, filter: $filter) {
          _id
          items {
            _id
            code
            fullName
            phone
          }
        }
      }
    `,
    variables: {filter: debouncedFilter},
    fetchPolicy: 'cache-first',
    partial: true
  })

  const {value} = useQuery({
    query: gql`
      query getVehicle($vehicleId: ID) {
        value: vehicle(vehicleId: $vehicleId) {
          _id
          code
          fullName
        }
      }
    `,
    variables: {vehicleId: props.value}
  })

  const onChange = option => {
    if (!option) {
      if (props.onChange) {
        props.onChange(null)
      }
      return
    }

    if (props.onChange) {
      props.onChange(option.value)
    }

    if (props.onSelect) {
      props.onSelect(option.vehicle)
    }
  }

  const cleanVehicle = item =>
    item
      ? {
          value: item._id,
          label: `#${item.code} ${item.fullName}`,
          vehicle: item
        }
      : null

  return (
    <div className={styles.container}>
      <Select
        value={cleanVehicle(value)}
        placeholder={props.placeholder}
        onChange={onChange}
        classNamePrefix="orion-select"
        isLoading={networkStatus !== 7 || isDebouncing}
        inputValue={filter}
        onInputChange={setFilter}
        options={(vehicles || {items: []}).items.map(cleanVehicle)}
      />
    </div>
  )
}
